import {
    Component, ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Output, Renderer2, ViewChild
} from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ModalController } from 'ionic-angular';
import { isString } from 'util';
import { FormHelper } from '../../../pages/form/form-helper';
import { VasAppFacade } from '../../../services/vas-app-facade.service';
import { ControlComponent } from '../../control.component';
import { RichTextControl } from '../rich-text-control.model';
import { RichTextModalArgs } from './rich-text-control-modal-args.model';
import { RichTextControlModalComponent } from './rich-text-control-modal.component';

@Component({
    selector: 'richtext',
    template: `
        <div class="button-container">
            <button
                ion-button
                icon-only
                clear
                (click)="onEditComment()"
            >
                <ion-icon name="create"></ion-icon>
            </button>
        </div>
        <div class="preview" #preview></div>
    `,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RichTextControlComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => RichTextControlComponent), multi: true}
    ]
})
export class RichTextControlComponent extends ControlComponent implements ControlValueAccessor {
    @Input() definition: RichTextControl;
    @Input() formGroup: FormGroup; // a reference to the formGroup for the job
    @Input('value') _value = '';
    @Output() changes: EventEmitter<any> = new EventEmitter();

    @ViewChild('preview') preview: ElementRef;

    protected displayValueCharacterLimit = 1000;

    constructor(
        protected elemRef: ElementRef,
        protected modalCtl: ModalController,
        protected appFacade: VasAppFacade,
        protected renderer: Renderer2
    ) {
        super(elemRef);
    }

    get hasContent(): boolean {
        return isString(this.value) && this.value.length > 0;
    }

    get showPreview(): boolean {
        return this.getOption('showPreview', false);
    }

    writeValue(value: any): void {
        super.writeValue(value);
        this.setDisplayValue(value);
    }

    updateValue(value: any): void {
        super.updateValue(value);
        this.setDisplayValue(value);
    }

    setDisplayValue(value: string): void {

        if (!this.showPreview) {
            return;
        }

        if (!this.preview) {
            return;
        }

        this.renderer.setProperty(this.preview.nativeElement, 'innerHTML', value);
    }

    onEditComment(): void {
        const modal = this.modalCtl.create(
            RichTextControlModalComponent,
            new RichTextModalArgs(
                this.definition.title,
                this.value,
                this.definition.defaultValue as string,
                this.definition.config.templateLookupTypeId
            )
        );

        modal.onDidDismiss(value => {
            // null means the user clicked outside the modal
            if (value === null) {
                return;
            }
            this.updateValue(value);
        });

        modal.present();
    }

    findFormGroupControl(name: string): FormControl {
        return FormHelper.findFormControl(name, this.formGroup);
    }

    getClasses(): object {
        return {
            ...super.getClasses(),
            'has-content': this.hasContent,
            'show-preview': this.showPreview,
            'not-show-preview': !this.showPreview
        };
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/rich-text/form/rich-text-control.component.ts